import { v4 as uuidv4 } from "uuid";
import { getTenants, getToken } from "../../Utils/JWTTokenUtil";

const getTenantName = () => {
  const stored = localStorage.getItem("selectedTenant");
  if (stored) return stored;
  const tenants = getTenants();
  return tenants[0] || "";
};

export const commonRequestHeaders = () => ({
  "vf-country-code": "*",
  "channel-id": "PAF",
  "vf-ext-bp-id": uuidv4(),
  vf_int_caller_id: uuidv4(),
  "vf-trace-transaction-id": uuidv4(),
  "tenant-name": getTenantName(),
});
